
const messages = {
    en: {
       cobrox: {
          compra: { 
            name: 'Compra',
            title: 'Compra management',
            subtitle: 'View, search, create, edit and delete Compra',
            creating: 'Creating Compra',
            editing: 'Editing Compra',
            deleting: 'Deleting Compra',
            showing: 'Showing Compra',
            menu: 'Compra',
            labels: {
                nombre: 'Nombre',
                nombreLegal: 'Nombre legal',
                fechaCompra: 'Fecha compra',
                porcentajeCompra: 'Porcentaje compra',
                cuit: 'CUIT',
                direccionLegal: 'Dirección legal',
                orden: 'Orden',
                estrategiaLiquidacion: 'Estrategia de liquidación',
                comisionPorVuelta: 'Comisión por vuelta',
                numeroVuelta: 'Número de vuelta',
                porcentajeComision: 'Porcentaje de comisión',
                agregarVuelta: 'Agregar vuelta',
                vuelta: 'Vuelta',
                vuelta1: 'Vuelta 1',
                vuelta2: 'Vuelta 2',
                vuelta3: 'Vuelta 3',
                vuelta4Mas: 'Vuelta 4+'
            },
            validation: {
                numeroVuelta: 'Debe ser un entero mayor o igual a 1',
                vueltaRepetida: 'La vuelta está repetida'
            },
          
          }
       }
    },
    es: {
       cobrox: {
          compra: { 
            name: 'Compra',
            title: 'Administración de Compra',
            subtitle: 'Ver, buscar, crear, editar, y borrar Compra',
            creating: 'Creando Compra',
            editing: 'Modificando Compra',
            deleting: 'Eliminando Compra',
            showing: 'Detalles de Compra',
            menu: 'Compra',
            labels: {
                nombre: 'Nombre',
                nombreLegal: 'Nombre legal',
                fechaCompra: 'Fecha compra',
                porcentajeCompra: 'Porcentaje compra',
                cuit: 'CUIT',
                direccionLegal: 'Dirección legal',
                orden: 'Orden',
                estrategiaLiquidacion: 'Estrategia de liquidación',
                comisionPorVuelta: 'Comisión por vuelta',
                numeroVuelta: 'Número de vuelta',
                porcentajeComision: 'Porcentaje de comisión',
                agregarVuelta: 'Agregar vuelta',
                vuelta: 'Vuelta',
                vuelta1: 'Vuelta 1',
                vuelta2: 'Vuelta 2',
                vuelta3: 'Vuelta 3',
                vuelta4Mas: 'Vuelta 4+'
            },
            validation: {
                numeroVuelta: 'Debe ser un entero mayor o igual a 1',
                vueltaRepetida: 'La vuelta está repetida'
            },
          
          }
       }
    },
    pt: {
       cobrox: {
          compra: { 
            name: 'Compra',
            title: 'Administração de Compra',
            subtitle: 'Ver, buscar, criar, editar e usar Compra',
            creating: 'Criando Compra',
            editing: 'Edição Compra',
            deleting: 'Apagando Compra',
            showing: 'Detalhes do Compra',
            menu: 'Compra',
            labels: {
                nombre: 'Nombre',
                nombreLegal: 'Nombre legal',
                fechaCompra: 'Fecha compra',
                porcentajeCompra: 'Porcentaje compra',
                cuit: 'CUIT',
                direccionLegal: 'Dirección legal',
                orden: 'Orden',
                estrategiaLiquidacion: 'Estrategia de liquidación',
                comisionPorVuelta: 'Comisión por vuelta',
                numeroVuelta: 'Número de vuelta',
                porcentajeComision: 'Porcentaje de comisión',
                agregarVuelta: 'Agregar vuelta',
                vuelta: 'Vuelta',
                vuelta1: 'Vuelta 1',
                vuelta2: 'Vuelta 2',
                vuelta3: 'Vuelta 3',
                vuelta4Mas: 'Vuelta 4+'
            },
            validation: {
                numeroVuelta: 'Debe ser un entero mayor o igual a 1',
                vueltaRepetida: 'La vuelta está repetida'
            },
          
          }
       }
    }
}

export default messages
